import BaseDataService from "./BaseDataService";
import axios from "axios";
import constants from "../constants";

class ApiPlaygroundService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'requests'
    this.http.defaults.baseURL = `${constants.baseURL}v1`
  }

  get(id) {
    return this.http.get(`/${this.moduleName}/${id}`);
  }

  create(data, api_key, is_save) {

    var http = axios.create({
      baseURL: constants.baseURL,
      headers: {
        "Content-Type": "application/json",
        "api-key": api_key
      }
    });

    if (localStorage['user'] && JSON.parse(localStorage['user'])['Token']) {
      http.defaults.headers['Authorization'] = "Bearer " + JSON.parse(localStorage['user'])['Token']
    }
    var requestUri = `managedservice/v1/hit`
    if (is_save) {
      requestUri = `${requestUri}?save_request_hit=true`
    }
    return http.post(requestUri, data);
  }

  search(payload) {
    return this.http.get(`/${this.moduleName}`, { params: payload });
  }
}

export default new ApiPlaygroundService();